
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create",
      function () {
        return require("private-next-pages/create.tsx");
      }
    ]);
  